import { configure, asString, asInt, asBoolean } from '@/core/browser/route-query.composable';

export enum QueryKeys {
    ActivateProfileToken = 'activateToken',
    All = 'all',
    ConfirmEmailChangeToken = 'confirmToken',
    Edit = 'edit',
    Email = 'email',
    EndDate = 'endDate',
    FilterBy = 'filterBy',
    Id = 'id',
    Page = 'page',
    PageSize = 'pageSize',
    ResetToken = 'resetToken',
    ReturnTypeHard = 'hardRedirect',
    ReturnUrl = 'returnUrl',
    SortBy = 'sortBy',
    SortByDirection = 'sortByDirection',
    SpaRequest = 'xhr',
    StartDate = 'startDate',
    Term = 'term',
    Title = 'title',
    VideoId = 'videoId',
    CheckoutStep = 'step',
    SpaSilentUpdate = 'spaSilentUpdate',
    ChangeCountry = 'change',
    PDPConfigurationId = 'configurationId',
    AltaPayRedirectData = 'redirectData',
    AltaPaySessionId = 'sessionId',
    OpenCustomizerModel = 'openCustomizerModel',
    // Keep the following value in sync with 'websiteTabInitiatorParam' in /clients/app/tab-shifter-extension/src/background.js
    // This will let the POS Edge extension find the correct tab - if multiple website tabs are open
    GotoPOS = 'GotoPOSTabInitiator',
    AddToBasket = 'addToBasket',
}

configure<QueryKeys>([
    QueryKeys.ActivateProfileToken,
    QueryKeys.All,
    QueryKeys.ConfirmEmailChangeToken,
    QueryKeys.Edit,
    QueryKeys.Email,
    QueryKeys.EndDate,
    QueryKeys.FilterBy,
    QueryKeys.Id,
    QueryKeys.Page,
    QueryKeys.ResetToken,
    QueryKeys.ReturnTypeHard,
    QueryKeys.ReturnTypeHard,
    QueryKeys.ReturnUrl,
    QueryKeys.SortBy,
    QueryKeys.SortByDirection,
    QueryKeys.SpaRequest,
    QueryKeys.StartDate,
    QueryKeys.Term,
    QueryKeys.Title,
    QueryKeys.VideoId,
    QueryKeys.CheckoutStep,
    QueryKeys.SpaSilentUpdate,
    QueryKeys.GotoPOS,
    QueryKeys.ChangeCountry,
    QueryKeys.AltaPayRedirectData,
    QueryKeys.AltaPaySessionId,
    QueryKeys.PDPConfigurationId,
    QueryKeys.OpenCustomizerModel,
    QueryKeys.AddToBasket,
], {
    [QueryKeys.All]: [QueryKeys.Page],
    [QueryKeys.EndDate]: [QueryKeys.Page],
    [QueryKeys.FilterBy]: [QueryKeys.Page],
    [QueryKeys.StartDate]: [QueryKeys.Page],
    [QueryKeys.Term]: [QueryKeys.Page],
}, {
    [QueryKeys.ActivateProfileToken]: asString,
    [QueryKeys.All]: asBoolean,
    [QueryKeys.ConfirmEmailChangeToken]: asString,
    [QueryKeys.Edit]: asString,
    [QueryKeys.Email]: asString,
    [QueryKeys.EndDate]: asString,
    [QueryKeys.FilterBy]: asString,
    [QueryKeys.Id]: asString,
    [QueryKeys.PageSize]: asInt,
    [QueryKeys.Page]: asInt,
    [QueryKeys.ReturnTypeHard]: asBoolean,
    [QueryKeys.ReturnUrl]: asString,
    [QueryKeys.SortByDirection]: asInt,
    [QueryKeys.SortBy]: asString,
    [QueryKeys.StartDate]: asString,
    [QueryKeys.Term]: asString,
    [QueryKeys.Title]: asString,
    [QueryKeys.VideoId]: asString,
    [QueryKeys.CheckoutStep]: asInt,
    [QueryKeys.SpaSilentUpdate]: asInt,
    [QueryKeys.GotoPOS]: asBoolean,
    [QueryKeys.ChangeCountry]: asBoolean,
    [QueryKeys.PDPConfigurationId]: asString,
    [QueryKeys.AltaPayRedirectData]: asString,
    [QueryKeys.AltaPaySessionId]: asString,
    [QueryKeys.OpenCustomizerModel]: asString,
    [QueryKeys.AddToBasket]: asBoolean,
});
